import { ethers } from 'ethers'

import contractAbi from '@src/contract/abi/tronOrderBookV2.abi.json'
import { createContextLogger } from '@src/utils/logger'

const receiptLogger = createContextLogger('Receipt')

export const processTronReceipt = (receipt: any) => {
    function decodeParams(types: string[], output: string, ignoreMethodHash: boolean = false): any[] {
        try {
            const AbiCoder = ethers.AbiCoder
            const ADDRESS_PREFIX = '41'

            let processedOutput = output.replace(/^0x/, '')

            if (ignoreMethodHash && processedOutput.length >= 8) {
                processedOutput = processedOutput.substring(8)
            }

            if (processedOutput.length % 64 !== 0) {
                throw new Error('The encoded string is not valid. Its length must be a multiple of 64.')
            }

            const abiCoder = new AbiCoder()
            const decodedParams = abiCoder.decode(types, '0x' + processedOutput)

            return decodedParams.reduce((obj: any[], arg: any, index: number) => {
                if (types[index] === 'address') {
                    arg = ADDRESS_PREFIX + arg.substr(2).toLowerCase()
                }
                obj.push(arg)
                return obj
            }, [])
        } catch (error) {
            receiptLogger.error('process tron receipt error', { error })
            return []
        }
    }

    const specificTypes: any = contractAbi.filter(item => item.name === 'OrderPlaced')
    const orderPlacedLogs = receipt.logs[0]

    function extractTypes(inputs: any[]): string[] {
        if (!Array.isArray(inputs)) {
            receiptLogger.error('Invalid inputs array:', { inputs })
            return []
        }

        return inputs.flatMap(input => {
            if (input.type === 'tuple' && input.components) {
                return input.components.map((component: any) => component.type)
            } else {
                return input.type
            }
        })
    }

    const allTypes = extractTypes(specificTypes[0].inputs)
    const result = decodeParams(allTypes.slice(1), orderPlacedLogs.data, false)
    receiptLogger.debug('result', { result })

    return [
        {
            srcToken: result[0],
            dstToken: result[1],
            lzCid: result[2],
            orderIndex: result[3],
            amount: result[4],
            price: 0,
            fee: result[6],
            transactionHash: receipt.blockHash,
            sellChain: 'tron',
        },
    ]
}
